import ExploreIcon from '@mui/icons-material/Explore';
import ReplayIcon from '@mui/icons-material/Replay';
import ExtensionIcon from '@mui/icons-material/Extension';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SchoolIcon from '@mui/icons-material/School';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GavelIcon from '@mui/icons-material/Gavel';
import type { SvgIconComponent } from '@mui/icons-material';

export type LoginLandingFeature = {
  icon: SvgIconComponent;
  title: string;
  description: string;
};

export const LOGIN_LANDING_FEATURES: LoginLandingFeature[] = [
  {
    icon: ExploreIcon,
    title: 'Position Explorer',
    description:
      'Browse master-level games from the Lichess Elite database and OTB Master Tournaments. See move statistics, popular lines, and filter by rating at every position.',
  },
  {
    icon: ReplayIcon,
    title: 'Replay Trainer',
    description:
      'Replay real games move by move. Miss a critical move and see the engine refutation — how your opponent punishes the mistake — before it lands in your review queue.',
  },
  {
    icon: CloudDownloadIcon,
    title: 'Import & Analyze',
    description:
      'Pull games from Chess.com and Lichess into your library. Endchess analyzes every move with engine-backed move quality — mistake and blunder thresholds calibrated to your rating level, so a 1200 and a 2200 each get feedback that fits their game.',
  },
  {
    icon: GavelIcon,
    title: 'Engine Refutations',
    description:
      'When you miss in replay, puzzles, or courses, Endchess shows the best opponent reply so you see how the mistake gets punished.',
  },
  {
    icon: SchoolIcon,
    title: 'Spaced Repetition Review',
    description:
      'Review missed moves, opening lines, and puzzles on a smart schedule. Endchess schedules what you need, when you need it.',
  },
  {
    icon: MenuBookIcon,
    title: 'Courses',
    description:
      'Published opening, middlegame, and endgame courses built from real master games. Work through lessons and drills — miss a line and see the refutation before you try again.',
  },
  {
    icon: ExtensionIcon,
    title: 'Tactical Puzzles',
    description:
      'Solve puzzles with instant feedback. Play wrong and watch the refutation line, then try again with the correct-move arrow. Tune difficulty to your rating and track daily progress.',
  },
];
